export type ExpenseCategory = "Kira" | "Personel" | "Malzeme" | "Reklam" | "Fatura" | "Temizlik / Bakım" | "Diğer";

export interface VendorBalance {
  vendor: string;
  totalBilled: number;
  totalPaid: number;
}

export interface Expense {
  id: string;
  date: string;
  category: ExpenseCategory;
  description: string;
  amount: number;
  paymentMethod: string;
  vendor: string;
  recurring: boolean;
  notes: string;
}

export const vendorBalances: VendorBalance[] = [
  { vendor: "Etiler Plaza Yönetimi", totalBilled: 56000, totalPaid: 56000 },
  { vendor: "Kuğu Spa Çalışanları", totalBilled: 326000, totalPaid: 326000 },
  { vendor: "Aroma Doğal Ürünler", totalBilled: 8500, totalPaid: 8500 },
  { vendor: "Google Ads", totalBilled: 13000, totalPaid: 13000 },
  { vendor: "Meta Business", totalBilled: 9000, totalPaid: 9000 },
  { vendor: "İGDAŞ", totalBilled: 6400, totalPaid: 6400 },
  { vendor: "İSKİ", totalBilled: 1700, totalPaid: 1700 },
  { vendor: "Temizlik Hizmetleri Ltd.", totalBilled: 3000, totalPaid: 3000 },
  { vendor: "Tekstil Çarşısı", totalBilled: 3200, totalPaid: 3200 },
  { vendor: "MNG Kargo", totalBilled: 450, totalPaid: 450 },
  { vendor: "Turkcell Superonline", totalBilled: 1300, totalPaid: 1300 },
  { vendor: "Spa Ekipman Ltd.", totalBilled: 2500, totalPaid: 2500 },
];

export const expenses: Expense[] = [
  {
    id: "exp-001",
    date: "2026-05-01",
    category: "Kira",
    description: "Mayıs ayı iş yeri kirası",
    amount: 28000,
    paymentMethod: "Havale",
    vendor: "Etiler Plaza Yönetimi",
    recurring: true,
    notes: "Her ayın 1'inde ödenir",
  },
  {
    id: "exp-002",
    date: "2026-05-01",
    category: "Personel",
    description: "Personel maaş ödemeleri",
    amount: 163000,
    paymentMethod: "Havale",
    vendor: "Kuğu Spa Çalışanları",
    recurring: true,
    notes: "7 personel toplam maaş",
  },
  {
    id: "exp-003",
    date: "2026-05-03",
    category: "Malzeme",
    description: "Masaj yağı ve kozmetik ürünleri",
    amount: 8500,
    paymentMethod: "Kredi Kartı",
    vendor: "Aroma Doğal Ürünler",
    recurring: false,
    notes: "Stok yenileme siparişi",
  },
  {
    id: "exp-004",
    date: "2026-05-05",
    category: "Reklam",
    description: "Google Ads kampanyası",
    amount: 6500,
    paymentMethod: "Kredi Kartı",
    vendor: "Google Ads",
    recurring: true,
    notes: "Aylık reklam bütçesi",
  },
  {
    id: "exp-005",
    date: "2026-05-05",
    category: "Reklam",
    description: "Meta Ads kampanyası",
    amount: 4500,
    paymentMethod: "Kredi Kartı",
    vendor: "Meta Business",
    recurring: true,
    notes: "Instagram ve Facebook reklamları",
  },
  {
    id: "exp-006",
    date: "2026-05-06",
    category: "Fatura",
    description: "Elektrik faturası",
    amount: 3200,
    paymentMethod: "Otomatik Ödeme",
    vendor: "İGDAŞ",
    recurring: true,
    notes: "Mayıs ayı elektrik",
  },
  {
    id: "exp-007",
    date: "2026-05-06",
    category: "Fatura",
    description: "Su faturası",
    amount: 850,
    paymentMethod: "Otomatik Ödeme",
    vendor: "İSKİ",
    recurring: true,
    notes: "Mayıs ayı su",
  },
  {
    id: "exp-008",
    date: "2026-05-07",
    category: "Temizlik / Bakım",
    description: "Haftalık derin temizlik",
    amount: 1500,
    paymentMethod: "Nakit",
    vendor: "Temizlik Hizmetleri Ltd.",
    recurring: true,
    notes: "Her hafta Perşembe",
  },
  {
    id: "exp-009",
    date: "2026-05-07",
    category: "Malzeme",
    description: "Peştemal ve havlu siparişi",
    amount: 3200,
    paymentMethod: "Havale",
    vendor: "Tekstil Çarşısı",
    recurring: false,
    notes: "60 adet peştemal, 40 havlu",
  },
  {
    id: "exp-010",
    date: "2026-05-08",
    category: "Diğer",
    description: "Kargo ve kurye giderleri",
    amount: 450,
    paymentMethod: "Nakit",
    vendor: "MNG Kargo",
    recurring: false,
    notes: "Hediye paketi gönderimleri",
  },
  {
    id: "exp-011",
    date: "2026-05-08",
    category: "Fatura",
    description: "İnternet ve telefon",
    amount: 650,
    paymentMethod: "Otomatik Ödeme",
    vendor: "Turkcell Superonline",
    recurring: true,
    notes: "İş yeri interneti",
  },
  {
    id: "exp-012",
    date: "2026-04-28",
    category: "Temizlik / Bakım",
    description: "Sauna bakımı ve onarım",
    amount: 2500,
    paymentMethod: "Kredi Kartı",
    vendor: "Spa Ekipman Ltd.",
    recurring: false,
    notes: "Yıllık sauna bakımı",
  },
];